import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-condiciones',
  templateUrl: './condiciones.component.html',
  styleUrls: ['./condiciones.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class CondicionesComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<CondicionesComponent>,
  	@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  submit() {
    this.dialogRef.close();
  }


}



// WEBPACK FOOTER //
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/modules/recuperar-pass/components/condiciones/condiciones.component.ts